import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';

import './assets/styles/index.scss';
import App from './App';
import React from 'react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);